var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetFontSizeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6108_210)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5009 7.64458C17.8819 8.30988 17.4033 9.13879 16.6367 9.1415L8.4072 9.17067C7.63583 9.17341 7.15194 8.33871 7.53763 7.67068L8.79995 5.48428C7.35505 5.59042 5.93995 6.19592 4.83511 7.30076C2.39057 9.7453 2.39057 13.7087 4.83511 16.1532C7.27965 18.5978 11.243 18.5978 13.6876 16.1532C14.8012 15.0395 15.4066 13.6143 15.5063 12.1574C15.5628 11.3309 16.2786 10.7067 17.1051 10.7632C17.9316 10.8197 18.5558 11.5356 18.4993 12.3621C18.3521 14.5146 17.4544 16.629 15.8089 18.2745C12.1928 21.8906 6.32991 21.8906 2.71379 18.2745C-0.902319 14.6584 -0.902319 8.79555 2.71379 5.17944C4.83621 3.05702 7.73261 2.18032 10.4944 2.54934L11.6776 0.500001C12.0633 -0.168031 13.0281 -0.166322 13.4114 0.503072L16.617 6.10103C16.6838 6.18816 16.7489 6.27624 16.8122 6.36523C16.9157 6.51076 16.9896 6.66845 17.0351 6.83111L17.5009 7.64458Z",
    fill: "url(#paint0_radial_6108_210)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6108_210",
    x: 0.00170898,
    y: 0,
    width: 19.5011,
    height: 21.9863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6108_210"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6108_210",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.00169 19) rotate(-56.3099) scale(25.2389 862.596)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67E974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434108,
    stopColor: "#BBFF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50E25F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AEF77"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetFontSizeIcon);
export default __webpack_public_path__ + "static/media/reset-font-size-icon.83eb7cb1920b580da9f32b44dc0123a0.svg";
export { ForwardRef as ReactComponent };